import { ArrowLeftOutlined } from '@ant-design/icons';
import { useIntl, useModel } from '@umijs/max';
import React from 'react';
import styles from './index.less';

const BackToMerchantListMenuItem: React.FC = () => {
  const intl = useIntl();
  const { isEntered, exitWorkspace } = useModel('merchantWorkspace');

  if (!isEntered) return null;

  return (
    <div className={styles.item} onClick={exitWorkspace}>
      <ArrowLeftOutlined className={styles.icon} />
      <span>
        {intl.formatMessage({
          id: 'component.merchantWorkspace.backToList',
          defaultMessage: 'Back to Merchant List',
        })}
      </span>
    </div>
  );
};

export default BackToMerchantListMenuItem;
